/**
 * Registro de paquetes de sector de la web (spec §4.3): la única puerta entre el núcleo y los paquetes. Agregar un
 * paquete es llamar aquí su `register…`.
 */
import { registerPublicSector } from './public-sector';

export function registerExtensions() {
  registerPublicSector();
}
